angular.module('unica_pages.pages_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// COOKIES PAGE
		.state('app.cookies_page', {
			url: '/cookies',
			views: {
				'mainContent': {
					templateUrl: './modules/pages/templates/cookies.html',
					controller: 'CookiesPageController'
				}
			},
			ncyBreadcrumb: {
				label: 'Informativa Estesa Cookies'
			}
		})

		// PRIVACY PAGE
		.state('app.privacy_page', {
			url: '/privacy',
			views: {
				'mainContent': {
					templateUrl: './modules/pages/templates/privacy.html',
					controller: 'PrivacyPageController'
				}
			},
			ncyBreadcrumb: {
				label: 'Informativa Privacy'
			}
		});


});

